<div class="p-6">
  <div class="flex justify-between items-center mb-6">
    <h1 class="text-2xl font-bold">Site Users</h1>
    @if (auth.canManageUsers$ | async) {
      <button
        (click)="openInviteModal()"
        [disabled]="!siteId"
        class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed">
        Invite user
      </button>
    }
  </div>

  <div class="bg-white rounded-lg shadow">
    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Role</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
            <th class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Daily Digest</th>
            <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr *ngIf="loading">
            <td colspan="5" class="px-6 py-4 text-center"><app-spinner></app-spinner></td>
          </tr>
          <tr *ngIf="!loading && users.length === 0">
            <td colspan="5" class="px-6 py-4 text-sm text-gray-500 text-center">No users yet. Invite someone to get started.</td>
          </tr>
          <tr *ngFor="let user of users">
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ user.email }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
              @if (user.role === 'PLATFORM_ADMIN') {
                <span class="text-sm">{{ roleLabel(user.role) }}</span>
              } @else {
                <select [value]="user.role" (change)="updateRole(user, $event)"
                  class="border rounded px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
                  @for (r of roles; track r.value) {
                    <option [value]="r.value" [selected]="r.value === user.role">{{ r.label }}</option>
                  }
                </select>
              }
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm">
              <span class="inline-block px-2 py-1 text-xs rounded"
                    [class.bg-yellow-100]="user.status === 'INVITED'"
                    [class.text-yellow-800]="user.status === 'INVITED'"
                    [class.bg-green-100]="user.status === 'ACTIVE'"
                    [class.text-green-800]="user.status === 'ACTIVE'"
                    [class.bg-gray-200]="user.status === 'DISABLED'"
                    [class.text-gray-700]="user.status === 'DISABLED'">
                {{ statusLabel(user.status) }}
              </span>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-center">
              <input type="checkbox"
                     [checked]="user.receiveDailyDigest"
                     (change)="toggleDailyDigest(user)"
                     class="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500 cursor-pointer" />
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-right space-x-3">
              @if (auth.canManageUsers$ | async) {
                @if (user.status === 'INVITED') {
                  <button (click)="resendInvite(user)" class="text-blue-600 hover:text-blue-900">Resend invite</button>
                }
                @if (user.status !== 'DISABLED') {
                  <button (click)="deactivateUser(user)" class="text-red-600 hover:text-red-900">Deactivate</button>
                }
                @if (user.status === 'DISABLED') {
                  <button (click)="reactivateUser(user)" class="text-green-700 hover:text-green-900">Reactivate</button>
                }
                <button (click)="deleteUser(user)" class="text-red-600 hover:text-red-900">Delete</button>
              }
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div *ngIf="showInviteModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  <div class="bg-white rounded-lg p-6 max-w-md w-full mx-4">
    <h3 class="text-lg font-semibold mb-4">Invite user</h3>
    <form [formGroup]="inviteForm" (ngSubmit)="submitInvite()">
      <div class="mb-4">
        <label class="block text-sm font-medium mb-2" for="email">Email</label>
        <input id="email" type="email" formControlName="email"
          class="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="user@example.com" />
      </div>
      <div class="mb-4">
        <label class="block text-sm font-medium mb-2" for="role">Role</label>
        <select id="role" formControlName="role"
          class="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500">
          <option *ngFor="let r of roles" [value]="r.value">{{ r.label }}</option>
        </select>
      </div>
      <div class="flex space-x-3 justify-end">
        <button type="button" (click)="closeInviteModal()"
          class="px-4 py-2 text-gray-600 border border-gray-300 rounded hover:bg-gray-50">
          Cancel
        </button>
        <button type="submit" [disabled]="inviteForm.invalid || isInviting"
          class="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50">
          {{ isInviting ? 'Sending…' : 'Send invite' }}
        </button>
      </div>
    </form>
  </div>
</div>

<app-confirmation-modal
  [show]="showDeactivateModal"
  title="Deactivate User"
  [message]="'Are you sure you want to deactivate ' + (userToDeactivate?.email || 'this user') + '?'"
  confirmText="Deactivate"
  (confirm)="confirmDeactivate()"
  (cancel)="cancelDeactivate()">
</app-confirmation-modal>

<app-confirmation-modal
  [show]="showDeleteModal"
  title="Delete User"
  [message]="'Permanently delete ' + (userToDelete?.email || 'this user') + '? This cannot be undone.'"
  confirmText="Delete"
  (confirm)="confirmDeleteUser()"
  (cancel)="cancelDeleteUser()">
</app-confirmation-modal>
